import moment from 'moment-timezone';

import content from '../mixins/content';
import { OFFERS } from '../selectors/constants';
import moneyFormatter from '../utils/formatter';
import { DEFAULT_MAX_APRS } from './constants';

import timezones from '../../data/timezones.json';

const { labels } = content;
const maxAPRAllowed = content.APR ? parseInt(content.APR.maxAPRAllowed, 10)
  : DEFAULT_MAX_APRS;

moment.tz.load(timezones);

function getFinanceTerm(offer) {
  let range;
  let min;
  let max;
  let term = '';

  if (offer.PaymentTerms && offer.PaymentTerms.FinanceTerms
      && offer.PaymentTerms.FinanceTerms[0]) {
    min = offer.PaymentTerms.FinanceTerms[0].TermMin;
    max = offer.PaymentTerms.FinanceTerms[0].TermMax;
    range = `${min}-${max}`;

    term += `<p class='offer-card-first-apr'>${labels.card.financeTermPrefix}
      ${range}
      ${labels.card.financeTermSuffix}</p>`;
  }

  if (offer.PaymentTerms && offer.PaymentTerms.FinanceTerms
      && offer.PaymentTerms.FinanceTerms[1]
      && maxAPRAllowed > 1) {
    min = offer.PaymentTerms.FinanceTerms[1].TermMin;
    max = offer.PaymentTerms.FinanceTerms[1].TermMax;
    range = `${min}-${max}`;

    term += `<p class='offer-card-second-apr'>${labels.card.secondFinancePaymentPrefix}
      ${offer.PaymentTerms.FinanceTerms[1].APR}%
      ${labels.card.secondFinanceTermPrefix}
      ${range}
      ${labels.card.secondFinanceTermSuffix}</p>`;
  }

  return term;
}

function getLeaseTerm(offer) {
  let months;
  let term = '';
  let dueMoney = '';

  if (offer.LeasePaymentInfo && offer.LeasePaymentInfo.TermMonths) {
    if (offer.LeasePaymentInfo.TotalDueAtSigning === 0) {
      months = `${offer.LeasePaymentInfo.TermMonths} - 1`;
    } else {
      months = offer.LeasePaymentInfo.TermMonths;
    }

    term += `<p>${labels.card.leaseTermPrefix}
      ${months}
      ${labels.card.leaseTermSuffix}</p>`;
  }

  if (offer.LeasePaymentInfo
    && offer.LeasePaymentInfo.TotalDueAtSigning !== undefined) {
    dueMoney = moneyFormatter(offer.LeasePaymentInfo.TotalDueAtSigning,
      labels.offerDetails.dollarSign);
    term += `<p>${dueMoney}
      ${labels.card.dueAtSigningSuffix}</p>`;
  }

  return term;
}

export function getOfferTerm(data) {
  let term = '';
  if (data.LeasePaymentInfo && data.LeasePaymentInfo.TermMonths) {
    term = `${data.LeasePaymentInfo.TermMonths.toString()} months`;
  } else if (data.PaymentTerms && data.PaymentTerms.FinanceTerms) {
    term = [];
    data.PaymentTerms.FinanceTerms.forEach((element) => {
      const termItem = `${element.TermMin} months - ${element.TermMax} months`;
      term.push(termItem);
    });
    term = term.join(' | ');
  }
  return term;
}

export function getMonthsBetween(start, end) {
  const startSplitted = start.split('-');
  const endSplitted = end.split('-');
  for (let i = 0; i < startSplitted.length; i++) startSplitted[i] = parseInt(startSplitted[i], 10);
  for (let i = 0; i < endSplitted.length; i++) endSplitted[i] = parseInt(endSplitted[i], 10);
  const date1 = new Date(startSplitted[0], startSplitted[1], startSplitted[2]);
  const date2 = new Date(endSplitted[0], endSplitted[1], endSplitted[2]);
  const year1 = date1.getFullYear();
  const year2 = date2.getFullYear();
  let month1 = date1.getMonth();
  let month2 = date2.getMonth();
  let result = 0;
  if (month1 === 0) {
    month1++;
    month2++;
  }
  result = ((year2 - year1) * 12) + (month2 - month1) + 1;
  return `${result.toString()} months`;
}

export default function getTerm(offer) {
  switch (offer.SalesProgramType) {
    case OFFERS.TYPES.FINANCE:
      return getFinanceTerm(offer);
    case OFFERS.TYPES.LEASE:
      return getLeaseTerm(offer);
    case OFFERS.TYPES.SPECIAL:
      return getFinanceTerm(offer);
    default:
      return '';
  }
}
